export const OPENING_MESSAGE = {
  id: 'opening',
  role: 'bot',
  text:
    "Hi, I'm your Privacy Assistant. I can explain your score, your findings, and what to do next — in plain language, using only what SafeSocial already shows for your account. I'm not a lawyer and I can't see the whole internet, only your scan results here.\n\nAsk me anything below, or tap a suggestion.",
};

/** Shown before the first user message (aligned with backend `help` suggestions). */
export const DEFAULT_SUGGESTION_CHIPS = [
  'Explain my risk score',
  'Summarize my risks',
  'Which platform is riskiest?',
  'What should I do first?',
  'What is an exposure?',
  'Compare my progress',
];

/** Rotating status under the typing indicator while waiting for the API. */
export const LOADING_HINTS = [
  'Checking your privacy findings…',
  'Reviewing your risk score…',
  'Looking at recent exposures…',
];

/**
 * @param {{ risk_level?: string, unresolved_count?: number, has_findings?: boolean } | null} hint from GET /api/chatbot/context/
 */
export function buildWelcomeChipLabels(hint) {
  if (!hint || hint.has_findings === false) {
    return ['What is an exposure?', 'How do scans work?', 'What shows up after a scan?'];
  }
  const level = String(hint.risk_level || '').toLowerCase();
  const total = Number(hint.unresolved_count) || 0;
  if (level === 'high' || total > 12) {
    return ['Why is my score high?', 'What should I fix first?', 'Should I worry?', 'Which app is the problem?'];
  }
  if (level === 'medium') {
    return ['What should I do next?', 'Explain this simply', 'Which platform should I check first?'];
  }
  return ['How can I stay protected?', 'Explain my score simply', 'What is an exposure?', 'Am I safe?'];
}

export const PANEL_PAPER_SX = {
  width: { xs: 'min(340px, calc(100vw - 32px))', sm: 360 },
  height: 500,
  maxHeight: 'min(500px, 72vh)',
  mb: 1,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 3,
  overflow: 'hidden',
  border: '1px solid',
  borderColor: 'rgba(148, 163, 184, 0.24)',
  boxShadow: '0 14px 36px rgba(2, 6, 23, 0.5)',
  backdropFilter: 'blur(12px)',
  backgroundColor: 'rgba(17, 26, 44, 0.98)',
};

/** Full-width embedded panel on `/privacy-assistant` (sidebar layout main column). */
export const PAGE_PANEL_SX = {
  width: '100%',
  maxWidth: 900,
  mx: 'auto',
  flex: 1,
  minHeight: { xs: 'min(56vh, 480px)', sm: 'min(64vh, 560px)', md: 'min(72vh, 640px)' },
  maxHeight: { xs: 'min(78vh, 720px)', md: 'min(85vh, 760px)' },
  mb: 0,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 3,
  overflow: 'hidden',
  border: '1px solid',
  borderColor: 'rgba(148, 163, 184, 0.24)',
  boxShadow: '0 14px 36px rgba(2, 6, 23, 0.5)',
  backdropFilter: 'blur(12px)',
  backgroundColor: 'rgba(17, 26, 44, 0.98)',
};

export const HEADER_SX = {
  bgcolor: '#18B89A',
  color: '#04211D',
  px: 2,
  py: 1.25,
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 1,
};

export const MESSAGES_AREA_SX = {
  flex: 1,
  overflowY: 'auto',
  p: 1.5,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  backgroundColor: 'rgba(10, 18, 32, 0.65)',
};
